// Album date registry, populated as albums load (see AlbumDetail). Used by the
// page-slide hierarchy to order album -> album transitions by date rather than
// id: dates aren't in the URL, so we remember them keyed by album id (which is)
// and look them up when deciding the slide direction.

const dates = new Map<number, number>();

/** Remember an album's date as a sortable YYYYMMDD number. No-op if unknown. */
export const rememberAlbumDate = (id: number, date: string | null | undefined): void => {
    if (!date) return;
    const n = Number(date.slice(0, 10).replace(/-/g, ''));
    if (Number.isFinite(n) && n > 0) dates.set(id, n);
};

/** The album's remembered date (YYYYMMDD), or undefined if not seen yet. */
export const albumDate = (id: number): number | undefined => dates.get(id);
